import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const RegionSwitch = ({ size, checked, onChange, formId, label, className }) => (
  <span className={classnames('switch-component switch-component-region', className)}>
    <div className={classnames('switch', size)}>
      <input type="checkbox" id={formId} className="switch-input"
        checked={checked}
        onChange={onChange} />
      <label className="switch-paddle switch-paddle-region" htmlFor={formId} />
    </div>
    {label && <div className="switch-label switch-label-region">{label}</div>}
  </span>
);

RegionSwitch.propTypes = {
  size: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  formId: PropTypes.string.isRequired,
};

export default RegionSwitch;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/RegionSwitch/index.js